import { render, staticRenderFns } from "./M2hChallenges.vue?vue&type=template&id=6122c65c&scoped=true&"
import script from "./M2hChallenges.vue?vue&type=script&lang=js&"
export * from "./M2hChallenges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6122c65c",
  null
  
)

export default component.exports